import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Switch, Route } from 'react-router-dom';
import AdServicesCheckout from './AdServicesCheckout';
import AdServicesProducts from './AdServicesProducts';
import { useHistory } from 'react-router-dom';
import useRequest from '../../../Hooks/useRequest';
import { useAdvertisers } from '../../../Contexts/AdvertisersContext';
import AdServicesDetails from './AdServicesDetails';
import usePost from '../../../Hooks/usePost';
import OrderSummary from './OrderSummary';

const AdServicesContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

const ConnectedAdServices = () => {
    const adServiceCategoryId = '';

    const { currentAdvertiser } = useAdvertisers();
    const { advertiserId } = { ...currentAdvertiser };
    const { data: allAdServices } = useRequest(`/getAllAdServices/${advertiserId}`);
    // const { data: allAdServicesByCategory } = useRequest(
    //     `/GetAllAdServicesByCategory/${advertiserId}/${adServiceCategoryId}`
    // );
    const { data: allAdServicesByCategory } = useRequest(`/GetAllAdServiceCategoriesWithAdServices/${advertiserId}`);
    const { post: postNewAdServiceOrder } = usePost('/PostNewAdServiceOrder');

    const history = useHistory();

    const [selectedCategory, setSelectedCategory] = useState({});
    const [selectedService, setSelectedService] = useState({});
    const [selectedTiers, setSelectedTiers] = useState({});
    const [myServicesData, setMyServicesData] = useState([]);

    console.log(selectedService, 'selected service');
    console.log(selectedTiers, 'tiers');

    const resetFields = () => {
        setSelectedService({});
        setSelectedTiers({});
    };

    const filterByCategory = (idx) => {
        const selectedCategory = allAdServicesByCategory.find((item, index) => idx === index);
        setSelectedCategory(selectedCategory);
    };

    const filterByMyServices = () => {
        const myServicesArray = allAdServicesByCategory
            ?.flatMap((item) => {
                const adServices = item?.adServices || [];
                const myServices = adServices?.filter((service) => service.advertiserId === advertiserId);

                // Log each iteration

                // Return the filtered array if it's not empty
                return myServices && myServices.length > 0 ? myServices : null;
            })
            .filter(Boolean); // Filter out null values

        // Update state with the filtered array
        setMyServicesData(myServicesArray);

        // Return the filtered array if you need to use it elsewhere
        return myServicesArray;
    };

    useEffect(() => {
        if (allAdServicesByCategory?.length > 0) {
            filterByMyServices();
            setSelectedCategory(allAdServicesByCategory[0]);
        }
    }, [allAdServicesByCategory]);

    useEffect(() => {
        if (!selectedService?.adServiceId) {
            history.push('/portal/adServices/viewAdServices');
        }
    }, [selectedService]);

    useEffect(() => {
        const handlePopstate = () => {
            resetFields();
        };

        window.addEventListener('popstate', handlePopstate);

        return () => {
            window.removeEventListener('popstate', handlePopstate);
        };
    }, []);

    const tierOption = Object.keys(selectedTiers)?.map((item, idx) => item)[0];
    const tierPrice = selectedTiers[tierOption]?.price;

    const handleCheckout = async (paymentIntentId) => {
        try {
            const resp = await postNewAdServiceOrder(
                {
                    adServiceId: selectedService?.adServiceId,
                    advertiserId: advertiserId,
                    purchaseLabel: `Ad Service Purchase - ${selectedService?.adServiceName}`,
                    purchasePrice: tierPrice,
                    stripePaymentId: paymentIntentId ? paymentIntentId : 'Not Applicable',
                },
                'POST'
            );

            return resp;
        } catch (err) {
            return err;
        }
    };

    const handleAfterCheckout = () => {
        resetFields();
        history.push('/portal/adServices/orderSummary');
        //route to new page
    };
    return (
        <AdServicesContainer>
            <Switch>
                <Route path="/portal/adServices/viewAdServices">
                    <AdServicesProducts
                        selectedCategory={selectedCategory}
                        history={history}
                        allAdServicesByCategory={allAdServicesByCategory}
                        filterByCategory={filterByCategory}
                        setSelectedService={setSelectedService}
                        myServicesData={myServicesData}
                    />
                </Route>
                <Route path="/portal/adServices/details">
                    <AdServicesDetails
                        history={history}
                        selectedService={selectedService}
                        selectedTiers={selectedTiers}
                        setSelectedService={setSelectedService}
                        setSelectedTiers={setSelectedTiers}
                        resetFields={resetFields}
                    />
                </Route>
                <Route path="/portal/adServices/checkout">
                    <AdServicesCheckout
                        history={history}
                        currentAdvertiser={currentAdvertiser}
                        selectedService={selectedService}
                        selectedTiers={selectedTiers}
                        handleCheckout={handleCheckout}
                        handleAfterCheckout={handleAfterCheckout}
                    />
                </Route>

                <Route path="/portal/adServices/orderSummary">
                    <OrderSummary
                        history={history}
                        currentAdvertiser={currentAdvertiser}
                        selectedService={selectedService}
                        selectedTiers={selectedTiers}
                        handleCheckout={handleCheckout}
                        handleAfterCheckout={handleAfterCheckout}
                    />
                </Route>
            </Switch>
        </AdServicesContainer>
    );
};

export default ConnectedAdServices;
